import { useTranslation } from "react-i18next";
import { useListTeamQuery } from "@/state/teamApi";

export default function AboutTeam() {
  const { t } = useTranslation();
  const { data, isLoading } = useListTeamQuery();
  const members = data?.data ?? [];

  return (
    <section className="bg-white py-20 lg:py-28">
      <div className="w-full px-6 lg:px-12">
        <p className="text-[#00C2C2] text-xs font-semibold tracking-widest uppercase mb-3">{t("teamTag")}</p>
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-12">
          <h2 className="text-4xl font-bold text-[#0A1628]">{t("teamTitle")}</h2>
          <p className="text-gray-500 text-base max-w-md leading-relaxed">
            {t("teamDesc")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {isLoading
            ? Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="animate-pulse">
                  <div className="rounded-2xl bg-gray-100 mb-4 h-64 w-full" />
                  <div className="h-4 bg-gray-100 rounded w-3/4 mb-2" />
                  <div className="h-3 bg-gray-100 rounded w-1/2 mb-3" />
                  <div className="h-3 bg-gray-100 rounded w-full mb-1" />
                  <div className="h-3 bg-gray-100 rounded w-5/6" />
                </div>
              ))
            : members.map((member) => (
                <div key={member.id} className="group">
                  <div className="rounded-2xl overflow-hidden mb-4 h-64 w-full relative bg-gray-100">
                    {member.photo ? (
                      <img
                        src={member.photo}
                        alt={member.name}
                        loading="lazy"
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center bg-[#0A1628]/10">
                        <span className="text-4xl font-bold text-[#0A1628]/30">
                          {member.name.split(" ").map((n) => n[0]).join("").slice(0, 2)}
                        </span>
                      </div>
                    )}
                  </div>
                  <h3 className="font-bold text-[#0A1628] text-base mb-0.5">{member.name}</h3>
                  <p className="text-[#00C2C2] text-sm font-semibold mb-2">{member.title}</p>
                  <p className="text-gray-500 text-sm leading-relaxed">{member.bio}</p>
                </div>
              ))}
        </div>
      </div>
    </section>
  );
}
